export default "__VITE_ASSET__0f3330ae__"